/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventKind } from './EventKind';
import {
    EventKindFromJSON,
    EventKindFromJSONTyped,
    EventKindToJSON,
    EventKindToJSONTyped,
} from './EventKind';

/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Event
     */
    time: Date;
    /**
     * 
     * @type {EventKind}
     * @memberof Event
     */
    kind: EventKind;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    aVehicleSerialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    aVehicleModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    aVehicleManufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    bVehicleSerialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    bVehicleModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    bVehicleManufacturer?: string | null;
    /**
     * Whether the badge enabled driver muting during the incident.
     * 
     * This is only set if `kind` is `EventKind::BadgeZoneViolation`.
     * @type {boolean}
     * @memberof Event
     */
    driverMutingEnabled?: boolean | null;
}



/**
 * Check if a given object implements the Event interface.
 */
export function instanceOfEvent(value: object): value is Event {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('aVehicleSerialNumber' in value) || value['aVehicleSerialNumber'] === undefined) return false;
    return true;
}

export function EventFromJSON(json: any): Event {
    return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'time': (new Date(json['time'])),
        'kind': EventKindFromJSON(json['kind']),
        'aVehicleSerialNumber': json['aVehicleSerialNumber'],
        'aVehicleModel': json['aVehicleModel'] == null ? undefined : json['aVehicleModel'],
        'aVehicleManufacturer': json['aVehicleManufacturer'] == null ? undefined : json['aVehicleManufacturer'],
        'bVehicleSerialNumber': json['bVehicleSerialNumber'] == null ? undefined : json['bVehicleSerialNumber'],
        'bVehicleModel': json['bVehicleModel'] == null ? undefined : json['bVehicleModel'],
        'bVehicleManufacturer': json['bVehicleManufacturer'] == null ? undefined : json['bVehicleManufacturer'],
        'driverMutingEnabled': json['driverMutingEnabled'] == null ? undefined : json['driverMutingEnabled'],
    };
}

export function EventToJSON(json: any): Event {
    return EventToJSONTyped(json, false);
}

export function EventToJSONTyped(value?: Event | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'time': value['time'].toISOString(),
        'kind': EventKindToJSON(value['kind']),
        'aVehicleSerialNumber': value['aVehicleSerialNumber'],
        'aVehicleModel': value['aVehicleModel'],
        'aVehicleManufacturer': value['aVehicleManufacturer'],
        'bVehicleSerialNumber': value['bVehicleSerialNumber'],
        'bVehicleModel': value['bVehicleModel'],
        'bVehicleManufacturer': value['bVehicleManufacturer'],
        'driverMutingEnabled': value['driverMutingEnabled'],
    };
}

